import * as React from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import { Afr, getSelectedAfr, updateTableFact } from '../../redux/AfrSlice';
import { Entity, getSelectedEntity } from '../../redux/EntitySlice';
import AccountEditorGridBulk from '../core/AccountEditorGridBulk';



const ExpendituresCoreDetail = (props: {
    doneFlag: string,
    noFlag: string,
    fundGroup: string | null,
    setHasData: (hasData: boolean) => void
}) => {

    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const afrYear = currentAfr ? currentAfr.year : 0;
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const dispatch = useAppDispatch();

    // Cell Handler
    const handleCellEdited = function (cell: any) {
        var row = cell.getRow();
        var rowid = row.getData().accountCode;
        var conceptId = row.getData().accountId;
        var fieldid = cell.getField();
        var newvalue = cell.getValue();
        dispatch(updateTableFact(
            {
                tableId: "uas_034_expenditures",
                rowId: rowid,
                fundGroup: fieldid,
                concept: conceptId,
                value: newvalue
            }));

    }

    return (
        <React.Fragment>

                <AccountEditorGridBulk
                tableName="uas_034_expenditures"
                gridData={[]}
                gridColumns={[]}
                gridOptions={{}}
                cellEditHandler={handleCellEdited}
                doneFlag={props.doneFlag}
                noFlag={props.noFlag}
                fundGroup={props.fundGroup}
                setHasData={props.setHasData}
                />

        </React.Fragment>
    );
}

export default ExpendituresCoreDetail;